import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsTaskEditComp from "./Component/TsTaskEditComp"


const TsTaskEdit =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsTaskEditComp />
        </div>
        <Footer />
        </>
    )
}

export default TsTaskEdit